// extracted by mini-css-extract-plugin
module.exports = {"DataStoresEmpty":"DataStoresEmpty_klroi"};